import { frontendURL } from '../../../../helper/URLHelper';
import {
  ensureControlPanelAccess,
  ensureControlPanelRoot,
} from 'dashboard/composables/masifi/useControlPanelAccess';

// Masifi: Panel de Control (brand-resellers-design.md §4). Registradas vía settings/masifi/masifi.routes.js (ya
// registrado en core) → 0 touchpoints nuevos. meta.permissions = administrador de la cuenta ancla; el guard exige
// además el alcance que devuelve /console/me (el backend revalida en cada endpoint).
const meta = { permissions: ['administrator'] };

export const controlPanelRoutes = [
  {
    path: frontendURL('accounts/:accountId/control-panel'),
    redirect: to => ({
      name: 'control_panel_summary',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/control-panel/summary'),
    name: 'control_panel_summary',
    component: () => import('./pages/ControlPanelSummary.vue'),
    meta,
    beforeEnter: ensureControlPanelAccess,
  },
  {
    path: frontendURL('accounts/:accountId/control-panel/accounts'),
    name: 'control_panel_accounts',
    component: () => import('./pages/ControlPanelAccounts.vue'),
    meta,
    beforeEnter: ensureControlPanelAccess,
  },
  {
    path: frontendURL('accounts/:accountId/control-panel/cloudflare'),
    name: 'control_panel_cloudflare',
    component: () => import('./pages/ControlPanelCloudflare.vue'),
    meta,
    beforeEnter: ensureControlPanelRoot,
  },
  {
    path: frontendURL('accounts/:accountId/control-panel/activity'),
    name: 'control_panel_activity',
    component: () => import('./pages/ControlPanelActivity.vue'),
    meta,
    beforeEnter: ensureControlPanelAccess,
  },
];
